// extracted by mini-css-extract-plugin
export var cardLayout = "_5o-1";
export var paginationContainer = "_5o-0";